module.exports = __webpack_public_path__ + "static/media/baseMeme16thumb.5cf034b9.jpg";